import React, { useEffect, useRef, useState } from "react";
import ModalBody from "../../../modals/modalBody";
import { useTranslate } from "@tolgee/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationsAUserHasAccessTo,
  searchForLocationsOnSlice,
} from "../../../../redux/slices/location/locationsList";
import SelectByPlatform from "./selectByPlatform";
import SelectByTag from "./selectByTag";
import LocationRow from "./locationRow";
import IsLoadingIndicator from "../../../isLoadingIndicator";
import { isLocationSelected } from "./utils";
import {
  addActivePlatformTemp,
  resetActiveLocationsTemp,
  setShowOnlySelectedPlatforms,
  setShowProfileGroupSelectModal,
  syncProfileGroupSelectState,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { PLATFORM_LIST } from "../../../../config/constants";
import { dispatch } from "../../../../redux/store";
import PlanningConfirmation from "../../cards/planningConfirmation";
import { ConfirmationModal } from "../confirmationModal";
import { relocatePublishButtons } from "../../utils/uploadMediaFile";
// Assuming ModalBody is imported from a library or defined elsewhere in your project
// the modal has two columns one with col-3 and the other with col-9

const ProfileGroupSelect: React.FC = () => {
  const {
    lomavisCreatorConfig,
    tempState: { creator_multipost_config: creatorMultipostConfig },
    creator_multipost_config: originalCreatorMultipostConfig,
    ui: { showOnlySelectedPlatforms, showProfileGroupSelectModal },
  } = useSelector((state: any) => state.lomavisCreator);
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { locations, filtredLocations, isLoading } = useSelector(
    (state: any) => state.locationsList
  );
  useEffect(() => {
    // Fetch data here
    if (lomavisCreatorConfig.is_multipost) {
      console.log("seems like its multipost");
      dispatch(getLocationsAUserHasAccessTo() as any);
    }
  }, [creatorMultipostConfig?.is_multipost]);

  const [showConfirm, setShowConfirm] = useState(false);
  return (
    <>
      {showProfileGroupSelectModal && (
        <ModalBody
          onClose={() => {
            //check if tempState has been changed
            // if yes show confirmation modal
            // if no close modal

            if (
              JSON.stringify(creatorMultipostConfig) !==
              JSON.stringify(originalCreatorMultipostConfig)
            ) {
              setShowConfirm(true);
            } else {
              dispatch(setShowProfileGroupSelectModal(false));
            }
          }}
        >
          <ConfirmationModal
            title={t("lomavisCreator.locationSelectionConfirmation.title")}
            body={t("lomavisCreator.locationSelectionConfirmation.body")}
            primaryText={t(
              "lomavisCreator.locationSelectionConfirmation.primaryText"
            )}
            secondaryText={t(
              "lomavisCreator.locationSelectionConfirmation.secondaryText"
            )}
            show={showConfirm}
            handleClose={() => {
              setShowConfirm(false);
              dispatch(setShowProfileGroupSelectModal(false));
            }}
            handlePrimary={() => {
              setShowConfirm(false);
            }}
            handleSecondary={() => {
              setShowConfirm(false);
              dispatch(setShowProfileGroupSelectModal(false));
            }}
          />
          <div
            className="d-flex flex-column "
            style={{ height: "calc(100% - 50px)" }}
          >
            <div className="flex-grow-1 p-2 bg-secondary h-100">
              <div className={"d-flex flex-row h-100 gap-2"}>
                <div className="d-flex align-items-stretch flex-column col-3 h-100">
                  <div className="card p-3  bg-white py-5">
                    <input
                      type="text"
                      className="form-control mb-3 form-control-sm"
                      placeholder={t("loamvisCreator.search_location")}
                      onChange={(e) => {
                        dispatch(
                          searchForLocationsOnSlice({
                            search: e.target.value,
                          }) as any
                        );
                      }}
                    />
                  </div>
                  <div className="mt-3" />
                  <SelectByPlatform />
                  <div className="mt-3" />
                  <SelectByTag />
                </div>

                <div className="col-9 d-flex flex-column h-100">
                  <div className="d-flex flex-column card bg-white p-3 py-5 h-100 overflow-auto">
                    <div className={"d-flex justify-content-between"}>
                      <div className="">
                        <div>
                          <span>
                            {t("lomavisCreator.selected_profile_groups")}
                            <span
                              id="selectedProfileGroupsCount"
                              className="ms-1"
                            >
                              {
                                locations.filter((location: any) => {
                                  return isLocationSelected(
                                    location.uuid,
                                    creatorMultipostConfig
                                  );
                                }).length
                              }
                            </span>

                            <span id="totalProfileGroupsCount">
                              {locations.length ? "/" + locations.length : ""}
                            </span>
                          </span>
                        </div>
                        <div className="d-flex flex-row mt-1">
                          <div className="me-1">
                            <div className="form-check form-switch form-check-custom form-check-success form-check-solid me-10">
                              <input
                                id="showOnlySelectedProfilegroupsSwitch"
                                className="form-check-input h-20px"
                                type="checkbox"
                                value={showOnlySelectedPlatforms}
                                onChange={(e: any) => {
                                  console.log(
                                    "on change is working:!",
                                    showOnlySelectedPlatforms
                                  );
                                  dispatch(
                                    setShowOnlySelectedPlatforms({
                                      showOnlySelectedPlatforms:
                                        e?.target?.checked,
                                    }) as any
                                  );
                                }}
                              />
                              <label className="form-check-label">
                                {t(
                                  "lomavisCreator.show_only_selected_profile_groups"
                                )}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={""}>
                        <div>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary me-2"
                            onClick={(e) => {
                              e.preventDefault();
                              locations.map((location: any) => {
                                PLATFORM_LIST.map((platform) => {
                                  if (location?.[`is_${platform}_linked`])
                                    dispatch(
                                      addActivePlatformTemp({
                                        locationUUid: location.uuid,
                                        platform: platform,
                                      })
                                    ) as any;
                                });
                              });
                            }}
                          >
                            {t("lomavisCreator.select_all")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={() =>
                              dispatch(resetActiveLocationsTemp({}))
                            }
                          >
                            {t("lomavisCreator.deselect_all")}
                          </button>
                        </div>
                      </div>
                    </div>

                    {isLoading && (
                      <div className="w-100 h-100 d-flex align-items-center">
                        <IsLoadingIndicator />
                      </div>
                    )}
                    <div className="d-flex flex-wrap mt-5 overflow-scroll">
                      {filtredLocations.map((location: any) => {
                        if (
                          showOnlySelectedPlatforms &&
                          !isLocationSelected(
                            location.uuid,
                            creatorMultipostConfig
                          )
                        )
                          return null;
                        return (
                          <LocationRow key={location.id} location={location} />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-2">
              <ActionsRow setShowConfirm={setShowConfirm} />
            </div>
          </div>
        </ModalBody>
      )}
    </>
  );
};

export default ProfileGroupSelect;
export const ActionsRow: React.FC<any> = ({ setShowConfirm }) => {
  const {
    tempState: { creator_multipost_config: creatorMultipostConfig },
    creator_multipost_config: originalCreatorMultipostConfig,
  } = useSelector((state: any) => state.lomavisCreator);
  const { t } = useTranslate();
  const [rightMargin, setRightMargin] = useState(0);
  const footerRef = useRef(null);
  useEffect(() => {
    relocatePublishButtons({ footerRef, setRightMargin });
  }, []);
  return (
    <div className="card p-3 bg-white  w-100 h-50px" ref={footerRef}>
      <div className="d-flex justify-content-end align-items-center">
        <button
          className="btn btn-secondary btn-sm me-2"
          onClick={() => {
            if (
              JSON.stringify(creatorMultipostConfig) !==
              JSON.stringify(originalCreatorMultipostConfig)
            ) {
              setShowConfirm(true);
            } else {
              dispatch(setShowProfileGroupSelectModal(false));
            }
          }}
        >
          {t("lomavisCreator.buttons.cancel")}
        </button>
        <button
          className="btn btn-primary btn-sm"
          style={{ marginRight: rightMargin + "px" }}
          onClick={() => {
            dispatch(setShowProfileGroupSelectModal(false));
            dispatch(syncProfileGroupSelectState());
          }}
        >
          {t("lomavisCreator.buttons.save")}
        </button>
      </div>
    </div>
  );
};
